import { Component, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';
import { ApiService } from 'src/app/shared/services/api.service';
import { MatModule } from 'src/app/appModules/mat.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommonService } from 'src/app/shared/services/common.service';
@Component({
  selector: 'app-subject-dictionary-import',
  standalone: true,
  imports: [CommonModule, MatModule, FormsModule],
  templateUrl: './subject-dictionary-import.component.html'
})
export class SubjectDictionaryImportComponent implements OnInit {
  excelData: any[] = [];
  invalidRows: string[] = [];
  courseList: any[] = [];
  selectedCourse: any = null;
  selectedCourseId: any | null = null;
  resultType: any = null;  
  importSummary: any = null;
  importSkipped: any[] = [];
  constructor(private api: ApiService, private common: CommonService) { }

  ngOnInit(): void {
    this.api.get('courses/list').subscribe(res => {
      if (res.success) this.courseList = res.data;
    });
  }

  onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) return;

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const workbook: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const data = XLSX.utils.sheet_to_json(sheet, { defval: '' });

      this.excelData = data;
      this.validateData();
    };
    reader.readAsBinaryString(target.files[0]);
  }

  validateData() {
    this.invalidRows = [];

    this.excelData.forEach((row, index) => {
      const requiredFields = ['CRSCODE', 'CRSENAME', 'SEM', 'SUBCODE', 'SUBNAME', 'SUBTYPE'];
      const missing = requiredFields.filter(field => !row[field] || row[field].toString().trim() === '');

      if (!this.selectedCourseId) {
        this.invalidRows.push(`Row ${index + 2}: Course not selected`);
      }

      if (missing.length > 0) {
        this.invalidRows.push(`Row ${index + 2}: Missing required fields: ${missing.join(', ')}`);
      }

      const validTypes = ['T', 'P', 'TP', 'NC', 'N']; // T = Theory, P = Practical, B = Both
      if (row['SUBTYPE'] && !validTypes.includes(row['SUBTYPE'])) {
        this.invalidRows.push(`Row ${index + 2}: Invalid SUBTYPE "${row['SUBTYPE']}"`);
      }
    });
  }

  importSubjects() {
    if (this.invalidRows.length > 0) {
      alert('Fix validation errors before importing.');
      return;
    }

    const payload = this.excelData.map(row => ({
      sub_code: row['SUBCODE'],
      subject_name: row['SUBNAME'],
      subject_type: row['SUBTYPE'],
      course_id: this.selectedCourseId.id,
      result_type: this.resultType,
      course_code: row['CRSCODE'],
      course_name: row['CRSENAME'],
      semester_number: row['SEM'],
      credits: row['CREDITS'],
      cie_max: row['CIEMAX'],
      cie_min: row['CIEMIN'],
      see_max: row['SEEMAX'],
      see_min: row['SEEMIN'],
      see_cond: row['SEECOND'],
      subject_max: row['SUBMAX'],
      subject_min: row['SUBMIN'],
      psee_tmax: row['PSEETMAX'],
      psee_tmin: row['PSEETMIN'],
      psee_pmax: row['PSEEPMAX'],
      psee_pmin: row['PSEEPMIN'],
      gtot_max: row['GTOTMAX'],
      gtot_min: row['GTOTMIN'],
      pathway: row['PATHWAY'],
      pathway_sub: row['PATHWAYSUB'],
      qn_code: row['QNCODE']
    }));

    this.api.post('courses/subject/import', payload).subscribe(resp => {
      if (resp && resp.success) {
        this.importSummary = resp.summary;
        this.importSkipped = resp.skipped;
        this.common.notification(resp.message);
        //   alert('Subjects imported successfully!');
        this.reset();
      } else {
        // alert('Failed to import subjects');
        this.common.notification(resp.message, true);
      }
    });
  }

  reset() {
    this.excelData = [];
    this.invalidRows = [];
    this.selectedCourseId = null;
  }
}

